import { ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';

export interface FormErrorProps {
  children: ReactNode;
  className?: string;
}

/**
 * Standardized error message display for forms
 */
export function FormError({ children, className = '' }: FormErrorProps) {
  return (
    <div data-tsx-id="form-error" className={`rounded-md bg-red-50 p-4 ${className}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <p className="text-sm text-red-700">{children}</p>
        </div>
      </div>
    </div>
  );
}
